<template>
  <v-container>
    <ValidationObserver ref="objects" v-slot="{ invalid }">
      <v-form>
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="Type" rules="required">
              <v-select
                v-model="defaultFileType"
                :items="allowedFileTypes"
                :menu-props="{ maxHeight: '400' }"
                label="Type"
                auto-select-first
                flat
              ></v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="justify-end">
            <v-btn class="primary" @click="okAction()" :disabled="invalid">Export</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import store from '@/store/index';
import ReportService from '@/services/ReportService';
import { getError } from '@/utils/helpers';

extend('required', required);

export default {
  name: 'BasicExportDialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    /**
     * The prefix to use for the report file name
     */
    reportFilenamePrefix: {
      type: String,
      default: 'Default'
    },
    /**
     * Name used for report in Laravel REST API
     */
    reportName: {
      type: String,
      default: 'basic'
    },
    /**
     * File types allowed for export
     */
    allowedFileTypes: {
      type: Array,
      default: () => ['pdf']
    },
    /**
     * The default file type to select for the export
     */
    defaultFileType: {
      type: String,
      default: 'pdf'
    }
  },
  methods: {
    /**
     * Create the file name for the export
     */
    filename() {
      let filename = this.reportFilenamePrefix;
      return filename.replace(/[^a-z0-9]/gi, '-') + '.' + this.defaultFileType;
    },
    /**
     * Save method for the form
     */
    async okAction() {
      ReportService.getReport({
        report: this.reportName,
        filename: this.filename(),
        filetype: this.defaultFileType
      }).catch(error => {
        store.dispatch('ui/snackbarError', getError(error));
      });
    }
  }
};
</script>
